/* eslint-disable */
import React, { useEffect, useState } from 'react'

import { Spinner } from '../../../components/UI/Spinner'
import { Header } from '../../../components/Header'
import { Footer } from '../../../components/Footer'
import BlogContainer from '../../../components/BlogContainer'
import { Posts } from '../../../models/blog'
import {
  GetStaticProps,
  NextPage,
  GetStaticPaths,
  GetStaticPropsContext
} from 'next'

type Props = {
  postsData: Posts[]
  error: boolean
}
interface Tag {
  id: number
  title: string
  slug: string
}
export const PostsByTag: NextPage<Props, any> = (props: Props) => {
  const { postsData, error } = props
  const [errorMsg, setErrorMsg] = useState('')
  useEffect(() => {
    if (error) {
      setErrorMsg('No Posts Found Under This Tag')
    } else {
    }
  }, [postsData, error])
  if (!error) {
    return (
      <>
        <Header />
        <div className="pt-8 px-0 container mx-auto">
          <BlogContainer categorySlug={'/tag'} posts={postsData} />
        </div>
        <Footer />
      </>
    )
  }
  if (errorMsg.length > 0) {
    return (
      <>
        <Header />
        <div className="pt-8 px-0 container mx-auto flex justify-center">
          <h1>{errorMsg}</h1>
        </div>
      </>
    )
  }
  return (
    <div
      className="pt-8 flex justify-center items-center container mx-auto"
      style={{ minHeight: '100vh' }}
    >
      <Spinner />
    </div>
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_BLOG_URL}/wp-json/wp/v2/tags?per_page=100`
  ).then()
  const data = await res.json()

  const paths = data.map((tag: Tag) => {
    return {
      params: {
        slug: tag.slug
      }
    }
  })
  return {
    paths,
    fallback: false
  }
}

export const getStaticProps: GetStaticProps = async (
  ctx: GetStaticPropsContext
) => {
  const slug = ctx.params !== undefined ? ctx.params.slug : '404'

  const res = await fetch(
    `${process.env.NEXT_PUBLIC_BLOG_URL}/wp-json/wpr/v1/tag/${slug}`
  ).then()

  const postsData = await res.json()

  if (postsData.length > 0) {
    return {
      props: {
        postsData: postsData,
        error: false
      }
    }
  } else {
    return {
      props: {
        postsData: postsData,
        error: true
      }
    }
  }
}

export default PostsByTag
